import React from 'react';
import { StyledSolicitationRow } from '../SolicitationProposersListRow';
import { ShimmerPlaceholderText } from '../../../../../../ui';
import * as ProposerName from '../columns/ProposerName';
import * as ProposerCompany from '../columns/ProposerCompany';
import * as ProposerDbeMwbe from '../columns/ProposerDbeMwbe';
import * as ProposerEmail from '../columns/ProposerEmail';
import * as ProposerPhone from '../columns/ProposerPhone';

export default function SolicitationProposersListRowShimmer() {
	return (
		<StyledSolicitationRow>
			<ProposerName.StyledCell>
				<ShimmerPlaceholderText />
			</ProposerName.StyledCell>

			<ProposerCompany.StyledCell>
				<ShimmerPlaceholderText />
			</ProposerCompany.StyledCell>

			<ProposerDbeMwbe.StyledCell>
				<ShimmerPlaceholderText />
			</ProposerDbeMwbe.StyledCell>

			<ProposerEmail.StyledCell>
				<ShimmerPlaceholderText />
			</ProposerEmail.StyledCell>

			<ProposerPhone.StyledCell>
				<ShimmerPlaceholderText />
			</ProposerPhone.StyledCell>
		</StyledSolicitationRow>
	);
}
